
  <div class="logo-container" id="home-icon">
    @if(expanded){
        <div class="logo-expanded-container" [ngClass]="{expanded: expanded, collapsed: !expanded}">
          <a routerLink="" class="link">
            <img src="{{ expandedImage }}" class="logo-icon" alt="GasQuest" />
          </a>
        </div>

        @if(secondaryImage){
          <div class="secondary-logo-container" [ngClass]="{expanded: expanded, collapsed: !expanded}">
            <a [href]="redirectionLink" target="_blank">
              <img src="{{ secondaryImage }}" class="logo-icon" alt="GasQuest"/>
            </a>
          </div>
        }
      
    }@else{
      <div class="logo-collapsed-container" [ngClass]="{expanded: expanded, collapsed: !expanded}">
        <img src="{{ collapsedImage }}" class="logo-icon" alt="GasQuest" />
      </div>
    }
  </div>
  <div class="divider"></div>
